import { personLabel } from './personLabel';
import type { AtRiskInterviewer } from '../../services/interviewLinksApi';

/**
 * Which interviewers to name when a link is (nearly) unbookable.
 *
 * Two rules, and both matter:
 *  - zero remaining slots is what makes someone the bottleneck. Counts are a
 *    SOLO pass per person server-side, so on a panel link the colleague who is
 *    free still shows their own slots and is not blamed.
 *  - an UNREADABLE calendar is never blamed. We do not know whether that person
 *    is free, and accusing them of being booked out is the one wrong answer this
 *    feature must not give — it is the whole reason `readable` exists.
 *
 * Shared by the at-risk banner and the invite dialog so the board and the
 * dialog can never name different people for the same link.
 */
export function bottleneckNames(perInterviewer: AtRiskInterviewer[]): string[] {
  return (perInterviewer ?? [])
    .filter((i) => i.readable && i.slots === 0)
    .map((i) => i.name || personLabel(i.email));
}
